import './index.scss';
import 'components/select';
import 'utils/autofill_by_query_string';
import 'utils/filter_form';
import 'utils/form_data_summary';

(function ($) {
  const $filterForm = $('#js-exams-filter-form');

  $filterForm
    .filterForm()
    .formDataSummary('.js-summary')
    .autoFillByQueryString()
    .lazyReady();
})(jQuery);
